<div>
  @if (showFilters) {
    <filters [filtersData]="filtersData" [showCenterButtons]="true" (filterValuesEvent)="getFiltersValues($event)">
    </filters>
  }
  @if (isFetchingTickets) {
    <div class="loading__container d-flex justify-content-center align-items-center">
      <mat-spinner [diameter]="36"></mat-spinner>
      <span class="loading__container-text ml-3">Loading tickets data</span>
    </div>
  }
  @if (!isFetchingTickets && (dataSource?.length ?? 0) === 0) {
    <div class="loading__container d-flex flex-column justify-content-center align-items-center">
      <img class="mb-2" src="../../../../../assets/svg/empty-state_no-ticket-data.svg" alt="" />
      <span style="font-weight: bold; margin-bottom: 0.5rem; color: #979797">No Tickets Data</span>
    </div>
  }
  <div [hidden]="isFetchingTickets || (dataSource?.length ?? 0) === 0" class="udt-table-container">
    <table matSort mat-table [dataSource]="dataSource" class="udt-table w-100" (matSortChange)="onSortEvent($event)">
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Ticket ID</th>
        <td mat-cell *matCellDef="let item" style="width: 130px; padding-right: 15px">
          <a [routerLink]="['/secured/managed-services/tickets', item.id]">{{ item.id }}</a>
          <!-- {{ item.id }} -->
        </td>
      </ng-container>

      <ng-container matColumnDef="statusName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
        <td mat-cell *matCellDef="let item" style="width: 100px; padding: 0 15px 0 5px">
          <div class="d-flex justify-content-start align-items-baseline">
            <div>
              <div class="status__dot mr-2" [ngStyle]="{ background: item.statusColor }"></div>
            </div>
            <span>{{ item.statusName }}</span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="summary">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Summary</th>
        <td mat-cell mat-header-cell *matCellDef="let item" style="width: 130px; padding-right: 20px">
          <div
            #summaryCell
            class="two-line-text"
            matTooltipClass="bigger-tooltip"
            [matTooltip]="summaryCell.scrollHeight > summaryCell.clientHeight ? item.summary : ''"
          >
            {{ item.summary }}
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="priorityName">
        <th mat-header-cell *matHeaderCellDef>Priority</th>
        <td mat-cell *matCellDef="let item" style="width: 130px; padding-right: 10px; padding-left: 0px">
          {{ item.priorityName }}
        </td>
        <!-- <td
          mat-cell
          *matCellDef="let item"
          style="width: 130px; padding-right: 10px"
          [ngStyle]="{ 'padding-left': isPendingTriagePriority(item) ? '25px' : '0px' }"
        >
          {{ isPendingTriagePriority(item) ? '-' : item.priorityName }}
        </td> -->
      </ng-container>

      <ng-container matColumnDef="relationship">
        <th mat-header-cell *matHeaderCellDef>Parent</th>
        <td mat-cell *matCellDef="let item" style="width: 130px; padding-right: 10px">{{ item.isParent }}</td>
      </ng-container>

      <ng-container matColumnDef="dateEntered">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Creation</th>
        <td mat-cell *matCellDef="let item" style="width: 120px; padding-right: 15px">
          {{ item.dateEntered | hubDate }}
        </td>
      </ng-container>

      <ng-container matColumnDef="lastUpdated">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Updated</th>
        <td mat-cell *matCellDef="let item" style="width: 120px; padding-right: 15px">
          {{ item.lastUpdated | hubDate }}
        </td>
      </ng-container>

      <ng-container matColumnDef="dateClosed">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Closed</th>
        <td mat-cell *matCellDef="let item" style="width: 120px; padding-right: 15px">
          {{ item.dateClosed ? (item.dateClosed | hubDate) : '-' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="boardName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Board</th>
        <td mat-cell *matCellDef="let item" style="width: 120px; padding-right: 15px">{{ item.boardName }}</td>
      </ng-container>

      <ng-container matColumnDef="businessUnitName">
        <th mat-header-cell *matHeaderCellDef>Business Unit</th>
        <td mat-cell *matCellDef="let item" style="width: 120px; padding-right: 15px">
          {{ item.businessUnitName ?? '-' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="contactFullName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Contact</th>
        <td mat-cell *matCellDef="let item" style="width: 120px">{{ item.contactFullName }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="tableColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: tableColumns"></tr>
    </table>
  </div>
  @if (!!dataSource?.length) {
    <div class="table-paginator">
      <mat-paginator
        [hidden]="isFetchingTickets"
        [length]="numberOfTickets"
        [pageIndex]="pageIndex"
        [pageSize]="pageSize"
        (page)="onPageChange($event)"
        showFirstLastButtons
      ></mat-paginator>
    </div>
  }
</div>
